import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { SignUpRoutingModule } from './sign-up-routing.module';
import { SignupComponent } from './pages/signup/signup.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SlsService } from 'src/app/core/services/sls.service';
import { ToastService } from 'src/app/core/toast.service';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { AuthService } from '../home/services/auth.service';
import { DetailsService } from '../home/services/details.service';
import { SubscriptionPlansService } from '../home/services/subscription-plans.service';
import { SignupSuccessfullyComponent } from './components/signup-successfully/signup-successfully.component';
import { EmailVerifiedSuccessfullyComponent } from './components/email-verified-successfully/email-verified-successfully.component';
import { SelectProfessionTypeComponent } from './components/select-profession-type/select-profession-type.component';
import { SignupPaymentFailedComponent } from './components/signup-payment-failed/signup-payment-failed.component';
import { SignupPaymentSuccessComponent } from './components/signup-payment-success/signup-payment-success.component';
import { ProfilePendingComponent } from './components/profile-pending/profile-pending.component';
import { SuccessfullySubscribedComponent } from './components/successfully-subscribed/successfully-subscribed.component';
import { BusinessTyesService } from './services/business-tyes.service';
import { CommonService } from './services/common.service';
import { EmailVerifyFailComponent } from './components/email-verify-fail/email-verify-fail.component';
import { NextTabService } from './services/next-tab.service';
import { LoginReqComponent } from './components/login-req/login-req.component';
import { AgmCoreModule } from '@agm/core';
import { PlansPaymentComponent } from './components/plans-payment/plans-payment.component';
import { NgxStripeModule } from 'ngx-stripe';
import { CatalogueService } from '../dashboard/modules/my-catalogues/services/catalogue.service';
import { SignupPlanPaymentsComponent } from './components/signup-plan-payments/signup-plan-payments.component';
import { RenewRequestComponent } from './components/renew-request/renew-request.component';
import { IncomProfComponent } from './components/incom-prof/incom-prof.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms'; // for [formControl]


@NgModule({
	declarations: [
		SignupComponent,
		SignupSuccessfullyComponent,
		EmailVerifiedSuccessfullyComponent,
		SelectProfessionTypeComponent,
		SignupPaymentFailedComponent,
		SignupPaymentSuccessComponent,
		ProfilePendingComponent,
		SuccessfullySubscribedComponent,
		EmailVerifyFailComponent,
		LoginReqComponent,
		PlansPaymentComponent,
		SignupPlanPaymentsComponent,
		RenewRequestComponent,
		IncomProfComponent,
		ContactDetailsComponent
	],
	imports: [
		CommonModule,
		SignUpRoutingModule,
		SharedModule,
		MatDatepickerModule,
		MatButtonModule,
		MatIconModule,
		ReactiveFormsModule,
		MatButtonToggleModule,
		NgxStripeModule.forChild("pk_test_51RmSGtFl6A4EMn9bKM99mGjRpPpldnTLgVjChRwSQ9OjWiBkbkmCaMxmKNUXasDsxShE2iVCxKKm5OqYla4GO7Ky00deXVnuW2"),
		AgmCoreModule
	],
	exports: [
		MatButtonToggleModule,
		MatIconModule,
	 
	  ],
	providers: [
		DatePipe,
		AuthService,
		DetailsService,
		MediaService,
		SubscriptionPlansService,
		ToastService,
		SlsService,
		BusinessTyesService,
		CommonService,
		NextTabService,
		CatalogueService
	],
})
export class SignUpModule { }
